import React, { useState } from 'react'
import { EMPTY_RECORD } from '../../../common/Constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from '@fortawesome/free-solid-svg-icons'

const TableInteractiveEntry = (props) => {
  const { elements, displayOrder, onClick, dragndropProps } = props
  const [commentsHovered, setCommentsHovered] = useState(false)
  const [coachCommentsHovered, setCoachCommentsHovered] = useState(false)

  const pointerCursorStyle = { cursor: 'pointer' }

  // Helper function to render the comments cell
  const renderCommentsCell = (content, commentsHovered, setCommentsHovered, displayParameter) => {
    if (!content || content === EMPTY_RECORD) {
      return <td key={displayParameter}>{EMPTY_RECORD}</td>
    }
    return (
      <td key={displayParameter} style={{ position: 'relative' }}>
        {commentsHovered && (
          <div className='table-interactive-entry-comment-popup table-interactive-entry-comment-popup--above'>
            {typeof content === 'string'
              ? content.split(/\n|\r|\r\n/).map((line, idx) => <p key={idx} style={{ margin: 0 }}>{line}</p>)
              : content}
          </div>
        )}
        <span
          onMouseEnter={() => setCommentsHovered(true)}
          onMouseLeave={() => setCommentsHovered(false)}
          style={{ cursor: 'pointer' }}
        >
          <FontAwesomeIcon icon={faComment} size='lg' />
        </span>
      </td>
    )
  }

  return (
    <tr onClick={onClick} style={onClick && pointerCursorStyle} ref={dragndropProps?.innerRef} {...dragndropProps?.draggableProps} {...dragndropProps?.dragHandleProps}>
      {displayOrder.map((displayParameter) => {
        const content = elements[displayParameter]
        if (displayParameter === 'comments') {
          return renderCommentsCell(content, commentsHovered, setCommentsHovered, displayParameter)
        }
        if (displayParameter === 'coachComments') {
          return renderCommentsCell(content, coachCommentsHovered, setCoachCommentsHovered, displayParameter)
        }

        if (content === undefined || content === null || Number.isNaN(content)) {
          return <td key={displayParameter}>{EMPTY_RECORD}</td>
        }

        // prevent a lot of decimals in table cell content
        if (typeof content === 'string' && content.endsWith('%')) {
          const number = parseFloat(content.slice(0, -1))
          if (!isNaN(number) && Math.trunc(number) !== number) {
            // return number as string with percentage symbol, but rounded up or down
            return <td key={displayParameter}>{(number.toFixed(0) + '%')}</td>
          }
        }

        return <td key={displayParameter}>{content}</td>
      })}
    </tr>
  )
}

export default TableInteractiveEntry
